import React from 'react';
import CustomTextField from './CustomTextField';
import { StyledTableCell } from '../styles';
import CustomBadge from './Badge';

const ScoreInput = ({
  group,
  playerWithBenefit,
  benefitOn,
  groupScore,
  handlePlayerScore,
  position,
}) => {
  return position == 'out'
    ? playerWithBenefit.awardedTo == group && benefitOn.length != 0
      ? benefitOn?.slice(9).map((item, index) => {
          return (
            <StyledTableCell align='center'>
              {item?.hasBenefit && <CustomBadge advantagePoint={1} />}

              <CustomTextField
                player={group}
                index={index + 9}
                handlePlayerScore={handlePlayerScore}
                item={item}
                value={
                  groupScore[group][index + 9] == undefined
                    ? ''
                    : groupScore[group][index + 9].score == 0
                    ? ''
                    : groupScore[group][index + 9].score
                }
              />
            </StyledTableCell>
          );
        })
      : [...Array(Number(9))].map((item, index) => (
          <StyledTableCell align='center'>
            <CustomTextField
              player={group}
              index={index + 9}
              handlePlayerScore={handlePlayerScore}
              value={
                groupScore[group][index + 9] == undefined
                  ? ''
                  : groupScore[group][index + 9].score == 0
                  ? ''
                  : groupScore[group][index + 9].score
              }
            />
          </StyledTableCell>
        ))
    : playerWithBenefit.awardedTo == group && benefitOn.length != 0
    ? benefitOn?.slice(0, 9).map((item, index) => {
        return (
          <StyledTableCell align='center'>
            {item?.hasBenefit && <CustomBadge advantagePoint={1} />}

            <CustomTextField
              player={group}
              index={index}
              handlePlayerScore={handlePlayerScore}
              item={item}
              value={
                groupScore[group][index] != undefined
                  ? groupScore[group][index].score
                  : ''
              }
            />
          </StyledTableCell>
        );
      })
    : [...Array(Number(9))].map((item, index) => (
        <StyledTableCell align='center'>
          <CustomTextField
            player={group}
            index={index}
            handlePlayerScore={handlePlayerScore}
            value={
              groupScore[group][index] != undefined
                ? groupScore[group][index].score
                : ''
            }
          />
        </StyledTableCell>
      ));
};

export default ScoreInput;
